import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { styled } from "styled-components";
import { toast } from "react-toastify";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import PretendardText from "./../../../component/atoms/text/pretendardText";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import Table from "../../../component/atoms/layout/table/table";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Th from "../../../component/atoms/layout/table/th";
import Td from "../../../component/atoms/layout/table/td";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import SearchBar from "./../../../component/atoms/input/searchBar";
import EventBtn from "../../../component/atoms/button/eventBtn";
import Checkbox from "./../../../component/atoms/input/checkbox";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import TableCount from "../../../component/molecules/tableCount";
import Pagination from "./../../../component/molecules/pagination";
import Popup from "../../../component/molecules/popup";

import PopupOverLay from "../../../component/templates/PopupOverlay";

import { route } from "./../../../router/route";
import scrollToTop from "./../../../util/scrollToTop";
import CouponApi from "../../../api/coupon.api";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import RedBtn from "../../../component/atoms/button/redBtn";
import Empty from "../../../component/molecules/empty";
import Modal from "../../../component/templates/Modal";
import moment from "moment";
import { formatNumberWithCommas } from "../../../util/formatNumber";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const OperationCoupon = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.operation_coupon)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");
  const [activationFilter, setActivationFilter] = useState();
  const [formFilter, setFormFilter] = useState("");

  const [activationList, setActivationList] = useState([
    {
      title: "자동발행",
      value: "AUTO",
    },
    {
      title: "지정발행",
      value: "ASIGN",
    },
    {
      title: "쿠폰코드",
      value: "CODE",
    },
  ]);

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setFormFilter(
      searchParams.get("formFilter") ? searchParams.get("formFilter") : ""
    );
    setActivationFilter(
      searchParams.get("activation")
        ? Boolean(searchParams.get("activation"))
        : ""
    );

    getCouponList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [couponList, setCouponList] = useState([]);

  const getCouponList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      if (searchParams.get("activation")) {
        data.activation =
          searchParams.get("activation") === "false" ? "Inactive" : "Active";
      }

      if (searchParams.get("formFilter")) {
        data.couponType = searchParams.get("formFilter");
      }

      const response = (await CouponApi.getList(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
        };
      });

      setCouponList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (couponList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = couponList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, couponList]); // eslint-disable-line react-hooks/exhaustive-deps

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      let delIds = checkedListStorage.map((item) => item.id);

      const data = {
        ids: delIds,
        allFlag: false,
      };

      await CouponApi.delete(data);

      sessionStorageInit();
      setDeleteModalOpen(false);
      toast(toastMsg.delete);
      getCouponList();

      navigate(
        `${route.operation_coupon}?page=1&keyword=${keyword}&activation=${activationFilter}&formFilter=${formFilter}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 활성 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(false);
  const [formFilterOpen, setFormFilterOpen] = useState(false);

  // ---------- 팝업 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState(false);

  // 쿠폰코드(단일) 사용 내역
  const [usedCouponList, setUsedCouponList] = useState([]);

  const getTitle = (title) => {
    switch (title) {
      case "ASIGN":
        return "지정발행";
      case "DOWNLOAD":
        return "고객 다운로드";
      case "AUTO":
        return "자동발행";
      case "CODE":
        return "쿠폰코드";

      default:
        return "";
    }
  };

  const getCouponCodeList = async (id, useCount) => {
    try {
      const data = {
        page: 1,
        size: 0,
        couponId: id,
      };

      const response = (await CouponApi.couponCodeList(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (1 - 1) * 0 - index,
          useCount: useCount,
        };
      });

      setUsedCouponList(processedResponse);
      setPopupOpen(true);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>쿠폰</TableTitle>

          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"쿠폰"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"제목, 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();

                    navigate(
                      `${route.operation_coupon}?page=1&keyword=${keyword}&activation=${activationFilter}&formFilter=${formFilter}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.operation_coupon}?page=1&keyword=${keyword}&activation=${activationFilter}&formFilter=${formFilter}`
                  );
                }}
              />
              {isWriteAuthority && (
                <EventBtn
                  onClick={() => {
                    navigate(route.operation_coupon_create);
                    scrollToTop();
                  }}
                  text={"쿠폰 추가하기"}
                />
              )}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <RedBtn
                style={{
                  backgroundColor: "#272829",
                }}
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
              >
                쿠폰 삭제
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* 쿠폰명/사용혜택 */}
              <col width="308px" />
              {/* 상태 */}
              <col width="91px" />
              {/* 쿠폰형식 */}
              <col width="124px" />
              {/* 사용/발행 */}
              <col width="117px" />
              {/* 사용기간 */}
              <col width="144px" />
              {/* 등록일 */}
              <col width="121px" />
              {/* 보기 */}
              <col width="83px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...couponList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          couponList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                {/* 제목 - 쿠폰명/사용혜택 */}
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    쿠폰명/사용혜택
                  </TableText>
                </Th>
                {/* 제목 - 상태 */}
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper
                        style={{
                          width: 115,
                        }}
                      >
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              navigate(
                                `${
                                  route.operation_coupon
                                }?page=1&keyword=${keyword}&activation=${true}&formFilter=${formFilter}`
                              );
                            }}
                          >
                            활성
                            {activationFilter ? (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="선택됨"
                              />
                            ) : null}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            navigate(
                              `${
                                route.operation_coupon
                              }?page=1&keyword=${keyword}&activation=${false}&formFilter=${formFilter}`
                            );
                          }}
                        >
                          숨김
                          {activationFilter ? null : (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                {/* 제목 - 쿠폰 형식 */}
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      쿠폰 형식
                    </TableText>
                    <img
                      className={formFilterOpen ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFormFilterOpen(!formFilterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {formFilterOpen && (
                      <FilterWrapper>
                        {activationList.map((item, index) => {
                          return (
                            <FilterTextWrapper
                              key={index}
                              style={{
                                minWidth: 130,
                              }}
                            >
                              <FilterText
                                onClick={() => {
                                  if (formFilter === item.value) {
                                    navigate(
                                      `${route.operation_coupon}?page=1&keyword=${keyword}&activation=${activationFilter}&formFilter=`
                                    );
                                  } else {
                                    navigate(
                                      `${route.operation_coupon}?page=1&keyword=${keyword}&activation=${activationFilter}&formFilter=${item.value}`
                                    );
                                  }
                                }}
                              >
                                {item.title}
                                {formFilter === item.value ? (
                                  <img
                                    src="/assets/admin/icons/ico_selectbox_checked.svg"
                                    alt="선택됨"
                                  />
                                ) : null}
                              </FilterText>
                            </FilterTextWrapper>
                          );
                        })}
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                {/* 제목 - 사용/발행 */}
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      textAlign: "right",
                      paddingRight: 30,
                    }}
                  >
                    사용/발행
                  </TableText>
                </Th>
                {/* 제목 - 사용기간 */}
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    사용기간
                  </TableText>
                </Th>
                {/* 제목 - 등록일 */}
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    등록일
                  </TableText>
                </Th>
                {/* 제목 - 보기 */}
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {couponList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "86px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    {/* 행 - 쿠폰명/사용혜택 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 5,
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: "272px",
                          }}
                        >
                          {item.title}
                        </TableText>
                        <TableText
                          style={{
                            maxWidth: "272px",
                            fontWeight: 500,
                            fontSize: "13px",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          {item.couponUseType === "KRW"
                            ? `${formatNumberWithCommas(item.discountAmount)}${
                                item.couponUseType === "PERCENT" ? "%" : "원"
                              }`
                            : item.couponUseType === "ANNUAL"
                            ? "1년 수강권"
                            : "평생 수강권"}
                          ({formatNumberWithCommas(item.minBuyAmount)}원 이상
                          구매시)
                        </TableText>
                      </div>
                    </Td>
                    {/* 행 - 상태 */}
                    <Td>
                      <TableText
                        style={{
                          color: `${
                            item.activation
                              ? "#009bde"
                              : "rgba(181, 181, 181, 0.5)"
                          }`,
                        }}
                      >
                        {item.activation ? "진행중" : "종료"}
                      </TableText>
                    </Td>
                    {/* 행 - 쿠폰 형식 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <TableText
                          style={{
                            textDecoration:
                              item.couponType === "CODE" && "underline",
                            cursor: item.couponType === "CODE" && "pointer",
                          }}
                          onClick={() => {
                            if (item.couponType === "CODE") {
                              getCouponCodeList(item.id, item.useCount);
                            }
                          }}
                        >
                          {item.couponType !== "CODE"
                            ? getTitle(item.couponType)
                            : `${getTitle(item.couponType)}(${
                                item.issueCount === 0 || item.issueCount == null
                                  ? "단일"
                                  : item.issueCount
                              }개)`}
                        </TableText>
                        {item.couponType === "DOWNLOAD" && (
                          <img
                            src="/assets/admin/icons/ico_link.svg"
                            alt="다운로드 링크 복사"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigator.clipboard.writeText(item.link);
                              toast(
                                "쿠폰 다운로드 링크가 클립보드에 복사되었습니다"
                              );
                            }}
                          />
                        )}
                      </div>
                    </Td>
                    {/* 행 - 사용/발행 */}
                    <Td>
                      {item.issueCount ? (
                        <TableText
                          style={{
                            textAlign: "right",
                            maxWidth: "87px",
                          }}
                        >
                          {item.useCount}회/{item.issueCount}회
                        </TableText>
                      ) : (
                        <TableText
                          style={{
                            textAlign: "right",
                            maxWidth: "87px",
                          }}
                        >
                          {item.useCount}회
                        </TableText>
                      )}
                    </Td>
                    {/* 행 - 사용기간 */}
                    <Td>
                      {item.couponPeriod === "EXPIRE" && (
                        <TableText
                          style={{
                            maxWidth: "120px",
                            fontWeight: "400",
                            fontSize: 14,
                            lineHeight: "20.25px",
                            overflow: "visible",
                            whiteSpace: "normal",
                            textOverflow: "clip",
                            wordBreak: "normal",
                          }}
                        >
                          발행일로부터
                          <br />
                          {item.expiredDay}일 까지
                        </TableText>
                      )}
                      {item.couponPeriod !== "EXPIRE" && (
                        <>
                          {item.endDate == null ? (
                            <TableText>기간 제한 없음</TableText>
                          ) : (
                            <TableText>
                              {moment(item.startDate).format("YYYY-MM-DD")} 부터
                              <br />
                              {moment(item.endDate).format("YYYY-MM-DD")} 까지
                            </TableText>
                          )}
                        </>
                      )}
                    </Td>
                    {/* 행 - 등록일 */}
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    {/* 보기 */}
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(`${route.operation_coupon_edit}/${item.id}`);
                          scrollToTop();
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {couponList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.operation_coupon}
            queryString={`keyword=${keyword}&activation=${activationFilter}&formFilter=${formFilter}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {popupOpen && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen(false);
          }}
        >
          <Popup
            headerTitle="쿠폰코드 사용 내역"
            noFooter={true}
            onClick={() => {
              setPopupOpen(false);
            }}
          >
            <table
              style={{
                width: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
              }}
            >
              <colgroup>
                {/* 합계: 630px */}
                {/* 구매번호 */}
                <col width="193px" />
                {/* 상품명 */}
                <col width="326px" />
                {/* 상태*/}
                <col width="111px" />
              </colgroup>
              <thead
                style={{
                  height: 46,
                  display: "table", // 테이블 스타일 유지
                  width: 630,
                  tableLayout: "fixed", // 고정 레이아웃 사용
                }}
              >
                <tr
                  style={{
                    height: 41,
                    borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <th
                    style={{
                      paddingLeft: 30,
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      NO
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      쿠폰코드
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      사용
                    </TableText>
                  </th>
                </tr>
              </thead>

              <tbody
                style={{
                  display: "block", // 블록 레벨로 설정
                  maxHeight: 400, // 최대 높이 설정
                  overflowY: "auto", // 세로 스크롤 활성화
                  overflowX: "hidden",
                  width: 630,
                }}
              >
                {usedCouponList.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      style={{
                        height: 46,
                        display: "table", // 테이블 스타일 유지
                        width: 630,
                        tableLayout: "fixed", // 고정 레이아웃 사용
                      }}
                    >
                      <td>
                        <TableText
                          style={{
                            paddingLeft: 30,
                          }}
                        >
                          {item.numbering}
                        </TableText>
                      </td>
                      <td>
                        <TableText>{item.code}</TableText>
                      </td>
                      <td>
                        <TableText>
                          {item.useFlag === null
                            ? item.useCount
                            : item.useFlag
                            ? "사용"
                            : "미사용"}
                        </TableText>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {/* <div
              style={{
                width: "100%",
                height: 58,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                padding: "0px 30px",
                borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                marginTop: 32,
              }}
            >
              <ExcelBtn
                style={{
                  backgroundColor: "#313233",
                }}
              />
            </div> */}
          </Popup>
        </PopupOverLay>
      )}

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}
    </>
  );
};

export default OperationCoupon;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;
